export const HOTSPOTS_LAYER_ZINDEX = 250;
